// src/components/AuthCheck.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom'; // Используем useNavigate для редиректа

const AuthCheck = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // Используем null для начала
  const navigate = useNavigate(); // Хук для навигации

  // Проверка на авторизацию
  useEffect(() => {
    // Извлекаем сессию из localStorage
    const session = JSON.parse(localStorage.getItem('session'));

    if (session && session.userId && session.token) {
      setIsAuthenticated(true); // Если сессия существует, пользователь авторизован
    } else {
      setIsAuthenticated(false); // Если сессия не существует, пользователь не авторизован
    }
  }, []);

  const handleLogin = () => {
    // Логика для авторизации (например, сохранение данных сессии в localStorage)
    const sessionData = {
      userId: 'user123',
      token: 'someToken',
    };
    localStorage.setItem('session', JSON.stringify(sessionData)); // Сохраняем данные в session
    setIsAuthenticated(true); // Обновляем состояние авторизации
    navigate('/'); // Перенаправляем на страницу профиля после авторизации
  };

  const handleLogout = () => {
    // Логика для выхода (удаляем данные сессии)
    localStorage.removeItem('session'); // Удаляем сессию
    setIsAuthenticated(false); // Обновляем состояние авторизации
    navigate('/'); // Перенаправляем на страницу авторизации после выхода
  };

  // Пока проверка авторизации не завершена, не отображаем контент
  if (isAuthenticated === null) {
    return null; // Можно показать индикатор загрузки вместо null
  }

  if (!isAuthenticated) {
    // Если не авторизован, показываем кнопку авторизации
    return (
      <div className="login-container">
        <h2>Вы не авторизованы</h2>
        <button onClick={handleLogin}>Авторизоваться</button>
      </div>
    );
  }

 // Если авторизован, рендерим дочерние компоненты
 return <>{children}</>;
};

export default AuthCheck;
